/** @import { ButtonHTMLAttributes } from 'react' */

const baseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  fontFamily: "inherit",
  fontWeight: 600,
  borderRadius: "4px",
  border: "1px solid transparent",
  cursor: "pointer",
  transition: "all 150ms ease",
};

const sizes = {
  sm: { padding: "6px 12px", fontSize: "12px", minHeight: "32px" },
  md: { padding: "10px 16px", fontSize: "14px", minHeight: "40px" },
  lg: { padding: "12px 20px", fontSize: "15px", minHeight: "44px" },
};

function variantStyle(variant) {
  switch (variant) {
    case "secondary":
      return {
        background: "var(--bg-elevated)",
        borderColor: "var(--border-bright)",
        color: "var(--text-primary)",
      };
    case "ghost":
      return {
        background: "transparent",
        borderColor: "transparent",
        color: "var(--text-secondary)",
      };
    case "danger":
      return {
        background: "var(--critical-dim)",
        borderColor: "var(--critical)",
        color: "var(--critical)",
      };
    case "primary":
    default:
      return {
        background: "var(--accent)",
        borderColor: "var(--accent)",
        color: "#0a0f1a",
      };
  }
}

export default function Button({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  onClick,
  children,
  className = "",
  type = "button",
  ...rest
}) {
  const v = variantStyle(variant);
  const s = sizes[size] || sizes.md;
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      className={className}
      style={{
        ...baseStyle,
        ...v,
        ...s,
        opacity: isDisabled ? 0.55 : 1,
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
      onMouseEnter={(e) => {
        if (isDisabled) return;
        if (variant === "primary") e.currentTarget.style.background = "var(--accent-hover)";
        if (variant === "ghost") e.currentTarget.style.background = "var(--bg-elevated)";
        if (variant === "secondary") e.currentTarget.style.borderColor = "var(--accent)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = v.background;
        e.currentTarget.style.borderColor = v.borderColor;
      }}
      {...rest}
    >
      {loading ? (
        <span
          aria-hidden
          style={{
            width: "14px",
            height: "14px",
            border: "2px solid currentColor",
            borderRightColor: "transparent",
            borderRadius: "50%",
            animation: "idwiz-spin 0.6s linear infinite",
          }}
        />
      ) : null}
      {children}
    </button>
  );
}
